import { render, staticRenderFns } from "./SupplierBrowse.vue?vue&type=template&id=15cecab0"
import script from "./SupplierBrowse.vue?vue&type=script&lang=ts"
export * from "./SupplierBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15cecab0')) {
      api.createRecord('15cecab0', component.options)
    } else {
      api.reload('15cecab0', component.options)
    }
    module.hot.accept("./SupplierBrowse.vue?vue&type=template&id=15cecab0", function () {
      api.rerender('15cecab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/SupplierBrowse.vue"
export default component.exports